import { render, staticRenderFns } from "./ThumbsUpSvg.vue?vue&type=template&id=211a4662&"
import script from "./ThumbsUpSvg.vue?vue&type=script&lang=ts&"
export * from "./ThumbsUpSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports